<template lang="pug">
.el_plan_menu
  .el_plan_menu_li(:class="{ active: !plan_is_anual && plan_interval_count == 36}", @click="setMonthly(36)", v-if="show_36month_menu")
    | 3年払い
    .el_plan_menu_saving ＼18か月分お得／
    .el_plan_menu_pop.el_underlineRed 50% OFF
  .el_plan_menu_li(:class="{ active: plan_is_anual}", @click="setAnual", v-if="show_annual_menu")
    | 1年払い
    .el_plan_menu_saving ＼3か月分お得／
    .el_plan_menu_pop 25% OFF
  .el_plan_menu_li(:class="{ active: !plan_is_anual && plan_interval_count == 6 }", @click="setMonthly(6)", v-if="show_6month_menu")
    | 6ヶ月払い
    .el_plan_menu_pop 30% OFF
  .el_plan_menu_li(:class="{ active: !plan_is_anual && plan_interval_count == 3}", @click="setMonthly(3)", v-if="show_3month_menu")
    | 3ヶ月払い
    .el_plan_menu_pop 20% OFF
  .el_plan_menu_li(:class="{ active: !plan_is_anual && plan_interval_count == 1}", @click="setMonthly(1)", v-if="show_month_menu")
    | 月払い
</template>

<script>



import Vue from 'vue';

export default {
  props: {
    interval: { type: String },
    interval_count: { type: String},
    for_lp: { type: Boolean, default: false},
    is_new_ui: { type: Boolean, default: false},
  },
  data(){
    return {
    }
  },
  methods: {
    setAnual(){
      this.$store.commit("user/setIsAnual", true)
      this.$store.commit("user/setIntervalCount", 1)
    },
    setMonthly(interval_count){
      this.$store.commit("user/setIsAnual", false)
      this.$store.commit("user/setIntervalCount", interval_count)
    },
    removeAnual(){
      this.$store.commit("user/setIsAnual", false)
    },
  },
  computed: {
    plan_is_anual(){
      return this.$store.state.user.is_anual
    },
    plan_interval_count(){
      return this.$store.state.user.interval_count
    },
    // 初期プランの種類を判定
    initial_plan_type(){
      // 3年払い
      if (this.interval == 'month' && this.interval_count == 36) {
        return '36month'
      }
      // 年間払い
      if (this.interval == 'year') {
        return 'annual'
      }
      // 月払い
      return 'month'
    },
    // 3年払いタブ: 新UIの場合のみ表示
    show_36month_menu(){
      if (this.for_lp) return true
      return this.is_new_ui
    },
    // 年割プランタブ: 3年払いプラン以外で表示
    show_annual_menu(){
      if (this.for_lp) return true
      return this.initial_plan_type !== '36month'
    },
    // 月払いタブ: 初期プランが月払いの時のみ表示
    show_month_menu(){
      if (this.for_lp) return true
      return this.initial_plan_type === 'month'
    },
    // 3ヶ月払いタブ: LPページのみ表示
    show_3month_menu(){
      return this.for_lp
    },
    // 6ヶ月払いタブ: LPページのみ表示
    show_6month_menu(){
      return this.for_lp
    }
  },
  async mounted(){
    if(this.interval == "month"){
      this.$store.commit("user/setIsAnual", false)
    } else {
      this.$store.commit("user/setIsAnual", true)
    }
    if(this.interval_count!=""){
      this.$store.commit("user/setIntervalCount", this.interval_count)
    } else {
      this.$store.commit("user/setIntervalCount", 1)
    }
    await Vue.nextTick()
  },
}
</script>
